<template>
    <div class="panel panel-default">
        <div class="panel-heading panel-heading-divider">
            <div class="float-right" v-if="hasToolsSlot">
                <slot name="tools"></slot>
            </div>
            {{ title }}
            <span class="panel-subtitle">{{ subtitle }}</span>
        </div>
        <div class="panel-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>

    export default {
        name: "panel",
        props: ["title", "subtitle"],
        computed: {
            hasToolsSlot() {
                return !!this.$slots['tools']
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/snippets/panel.vue